import { Tooltip } from '@fortress-technology-solutions/fortress-component-library/Atoms';

export const ConditionalTooltip = ({ show, children, ...tooltipProps }) => {
  return show ? <Tooltip {...tooltipProps}>{children}</Tooltip> : children;
};

export default ConditionalTooltip;
